export default "__VITE_ASSET__kbG$f3FFPYGya0JEuXDYYw__"